import React from 'react';
import Form from './SignUpForm';

const SignUpForm = ({ ...props, signupUser, errors, authErrors }) => (
  <Form {...props} signupUser={signupUser} errors={errors} authErrors={authErrors} />
);

export default SignUpForm;


// WEBPACK FOOTER //
// src/components/SignUpForm/index.js